import { handleize } from '../../core/helpers';

export default (selected_color_name, quickview = false) => {
  const prefix = (quickview) ? '-quickview' : '';
  const is_plus = selected_color_name.includes('Plus Size - ');

  const title_text = is_plus ? 'Product info for size 1X' : 'Product info for size small';
  const selector = quickview ? 
    '#quicklook-modal [data-extra-product-info-title]' : 
    '[data-product-overview] [data-extra-product-info-title]';
    
  const title_element = document.querySelector(selector);
  if (title_element) {
    title_element.innerHTML = title_text;
  }

  // if (!$(`[data${prefix}-extra-description]`).length || !$(`[data${prefix}-extra-height]`).length || !$(`[data${prefix}-extra-size]`).length || !$(`[data${prefix}-extra-hip]`).length || !$(`[data${prefix}-extra-waist]`).length || !$(`[data${prefix}-extra-bust]`).length || !$(`[data${prefix}-extra-fit]`).length || !$(`[data${prefix}-extra-length]`).length || !$(`[data${prefix}-extra-inseam]`).length) {
  //   return;
  // }

  // Product extra data set at a style (color) level
  const extra_data = JSON.parse($(`[data${prefix}-product-extra-variant-json]`).html());
  const selected_color_handle = handleize(selected_color_name);
  const style_extra_data_defaut = _.find(extra_data, { color: 'default' });

  // Some fields can be null on some products (gift cards...)
  style_extra_data_defaut.description = style_extra_data_defaut.description || '';
  style_extra_data_defaut.sizefit_height = style_extra_data_defaut.sizefit_height || '';
  style_extra_data_defaut.sizefit_size = style_extra_data_defaut.sizefit_size || '';
  style_extra_data_defaut.sizefit_hip = style_extra_data_defaut.sizefit_hip || '';
  style_extra_data_defaut.sizefit_waist = style_extra_data_defaut.sizefit_waist || '';
  style_extra_data_defaut.sizefit_bust = style_extra_data_defaut.sizefit_bust || '';
  style_extra_data_defaut.sizefit_fit = style_extra_data_defaut.sizefit_fit || '';
  style_extra_data_defaut.sizefit_length = style_extra_data_defaut.sizefit_length || '';
  style_extra_data_defaut.sizefit_inseam = style_extra_data_defaut.sizefit_inseam || '';

  let style_extra_data = style_extra_data_defaut;

  if (selected_color_name !== '') {
    style_extra_data = _.find(extra_data, { color: selected_color_handle });
  }

  if (typeof style_extra_data === 'undefined') {
    style_extra_data = style_extra_data_defaut;
  }

  let extra_description = '';
  const extra_desc_el = document.querySelector(`[data${prefix}-extra-description]`);
  if (extra_desc_el) {
    extra_description = style_extra_data.description.length ? style_extra_data.description : style_extra_data_defaut.description;
    extra_desc_el.innerHTML = extra_description;

    (extra_description === null || extra_description === '') ? extra_desc_el.parentElement.classList.add('visually-hidden') : extra_desc_el.parentElement.classList.remove('visually-hidden');
  }

  let extra_height = '';
  const extra_height_el = document.querySelector(`[data${prefix}-extra-height]`);
  if (extra_height_el) {
    extra_height = style_extra_data.sizefit_height.length ? style_extra_data.sizefit_height : style_extra_data_defaut.sizefit_height;
    extra_height_el.innerHTML = extra_height;

    (extra_height === null || extra_height === '') ? extra_height_el.parentElement.classList.add('visually-hidden') : extra_height_el.parentElement.classList.remove('visually-hidden');
  }

  let extra_size = '';
  const extra_size_el = document.querySelector(`[data${prefix}-extra-size]`);
  if (extra_size_el) {
    extra_size = style_extra_data.sizefit_size.length ? style_extra_data.sizefit_size : style_extra_data_defaut.sizefit_size;
    extra_size_el.innerHTML = extra_size;

    (extra_size === null || extra_size === '') ? extra_size_el.parentElement.classList.add('visually-hidden') : extra_size_el.parentElement.classList.remove('visually-hidden');
  }

  let extra_hip = '';
  const extra_hip_el = document.querySelector(`[data${prefix}-extra-hip]`);
  if (extra_hip_el) {
    extra_hip = style_extra_data.sizefit_hip.length ? style_extra_data.sizefit_hip : style_extra_data_defaut.sizefit_hip;
    extra_hip_el.innerHTML = extra_hip;

    (extra_hip === null || extra_hip === '') ? extra_hip_el.parentElement.classList.add('visually-hidden') : extra_hip_el.parentElement.classList.remove('visually-hidden');
  }

  let extra_waist = '';
  const extra_waist_el = document.querySelector(`[data${prefix}-extra-waist]`);
  if (extra_waist_el) {
    extra_waist = style_extra_data.sizefit_waist.length ? style_extra_data.sizefit_waist : style_extra_data_defaut.sizefit_waist;
    extra_waist_el.innerHTML = extra_waist;

    (extra_waist === null || extra_waist === '') ? extra_waist_el.parentElement.classList.add('visually-hidden') : extra_waist_el.parentElement.classList.remove('visually-hidden');
  }

  let extra_bust = '';
  const extra_bust_el = document.querySelector(`[data${prefix}-extra-bust]`);
  if (extra_bust_el) {
    extra_bust = style_extra_data.sizefit_bust.length ? style_extra_data.sizefit_bust : style_extra_data_defaut.sizefit_bust;
    extra_bust_el.innerHTML = extra_bust;

    (extra_bust === null || extra_bust === '') ? extra_bust_el.parentElement.classList.add('visually-hidden') : extra_bust_el.parentElement.classList.remove('visually-hidden');
  }

  let extra_fit = '';
  const extra_fit_el = document.querySelector(`[data${prefix}-extra-fit]`);
  if (extra_fit_el) {
    extra_fit = style_extra_data.sizefit_fit.length ? style_extra_data.sizefit_fit : style_extra_data_defaut.sizefit_fit;
    extra_fit_el.innerHTML = extra_fit;

    (extra_fit === null || extra_fit === '') ? extra_fit_el.parentElement.classList.add('visually-hidden') : extra_fit_el.parentElement.classList.remove('visually-hidden');
  }

  let extra_length = '';
  const extra_length_el = document.querySelector(`[data${prefix}-extra-length]`);
  if (extra_length_el) {
    extra_length = style_extra_data.sizefit_length.length ? style_extra_data.sizefit_length : style_extra_data_defaut.sizefit_length;
    extra_length_el.innerHTML = extra_length;

    (extra_length === null || extra_length === '') ? extra_length_el.parentElement.classList.add('visually-hidden') : extra_length_el.parentElement.classList.remove('visually-hidden');
  }

  let extra_inseam = '';
  const extra_inseam_el = document.querySelector(`[data${prefix}-extra-inseam]`);
  if (extra_inseam_el) {
    extra_inseam = style_extra_data.sizefit_inseam.length ? style_extra_data.sizefit_inseam : style_extra_data_defaut.sizefit_inseam;
    extra_inseam_el.innerHTML = extra_inseam;

    (extra_inseam === null || extra_inseam === '') ? extra_inseam_el.parentElement.classList.add('visually-hidden') : extra_inseam_el.parentElement.classList.remove('visually-hidden');
  }

  // Show/hide extra info
  const has_extra_info = extra_height || extra_size;
  const extra_size_height_el = document.querySelector(`[data${prefix}-extra-size-height]`);
  const extra_size_height_title_el = document.querySelector(`[data${prefix}-extra-size-height-title]`);
  
  [extra_size_height_el, extra_size_height_title_el].forEach(el => {
    if (el) {
      el.classList.toggle('visually-hidden', !has_extra_info);
    }
  });
};
